import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FlatButton from 'material-ui/FlatButton';
import FontIcon from 'material-ui/FontIcon';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import _ from 'lodash';

import { fetchEmployees } from '../../actions/employees';
import { showDialog, hideDialog, showError } from '../../actions/dialogs';
import { toArray, formatLocation, filterTask } from '../../utils/helper';
import { saveTaskAssignmentsRoutine, fetchTasksRoutine } from '../../routines';
import icons from '../../utils/icons';

import AssignEmployeesToStagesDialog from '../AssignEmployeesToStagesDialog';
import ReduxDialog from '../Common/ReduxDialog';

import styles from './styles';
import commonStyles from '../styles';

const emptyExtractor = (task) => '';
const originExtractor = (task) => task.origin ? `${task.origin.building || ''}, ${task.origin.space || ''}` : '';
const destinationExtractor = (task) => task.destination ? `${task.destination.building || ''}, ${task.destination.space || ''}` : '';

class AssignResourcesToTasks extends Component {
  static propTypes = {
    job: PropTypes.object,
    employees: PropTypes.array.isRequired,

    fetchEmployees: PropTypes.func.isRequired,
    fetchTasks: PropTypes.func.isRequired,

    showDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    showError: PropTypes.func.isRequired,

    tasks: PropTypes.array.isRequired,

    saveTaskAssignments: PropTypes.func.isRequired,
  };

  state = {
    selectedRows: [],
    query: [{
      where: emptyExtractor,
      condition: '',
      substring: '',
    }],
  };

  componentWillMount() {
    this.props.fetchEmployees();
    this.props.fetchTasks(this.props.job.id);
  }

  // componentWillReceiveProps(nextProps) {
  //   console.log('nextProps.job', nextProps.job);
  //   if (nextProps.job && nextProps.job.id) {
  //     nextProps.fetchTasks(nextProps.job.id);
  //   }
  // }

  handleUpdateInput = (searchText, a, b, c) => {
    this.setState({
      searchText,
    });
  };

  handleSelectEmployee = (employee) => {
    this.setState({
      employee,
    });
  };

  handleSelectRole = (role) => {
    this.setState({
      role,
    });
  };

  handleWhereChange = (value, index) => {
    const temp = this.state.query;
    temp[index].where = value;
    this.setState({ query: temp });
  };

  handleConditionChange = (value, index) => {
    const temp = this.state.query;
    temp[index].condition = value;
    this.setState({ query: temp });
  };

  handleChange = (event, value, index) => {
    const temp = this.state.query;
    temp[index].substring = value.trim();
    this.setState({ query: temp });
  };

  handleSave = () => {
    this.props.saveTaskAssignments(this.props.tasks.filter((task) => task.changed));
    this.props.hideDialog('assignResourcesToTasks');
  };

  handleRemoveAssignment = (task) => {
    console.log('handleRemoveAssignment', task);
  };

  addFilter() {
    const temp = this.state.query;
    temp.push({
      where: emptyExtractor,
      condition: 'Contains',
      substring: '',
    });
    this.setState({
      query: temp,
    });
  }

  handleRemoveFilter(index) {
    const temp = this.state.query;
    temp.splice(index, 1);
    this.setState({ query: temp });
  }

  handleAssignEmployeesToStages() {
    const { job } = this.props;
    if (this.state.selectedRows.length < 1) {
      return this.props.showError('Validation Errors', 'Please select the tasks you want to assign employees to');
    }

    // this.props.selectTasksSuccess(this.state.selectedRows);
    const tasks = this.props.tasks.filter((task, idx) => this.state.selectedRows.indexOf(idx) >= 0);
    this.props.showDialog('assignEmployeesToStages', {
      stages: job.profile.stages,
      tasks,
    });
    return null;
  }

  handleTaskSelection = (evt) => {
    let selectedRows = [];
    switch (evt) {
      case 'all':
        selectedRows = _.range(0, this.state.limit);
        break;
      case 'none':
        selectedRows = [];
        break;
      default:
        selectedRows = evt;
        break;
    }

    this.setState({
      selectedRows,
    });


    // switch (selectedRows) {
    //   case 'all':
    //     selectedRows = _.range(0, this.props.tasks.length);
    //     break;
    //   case 'none':
    //     selectedRows = [];
    //     break;
    //   default:
    //     break;
    // }

    // let tasks = selectedRows;
    // if (selectedRows === 'all') {
    //   tasks = _.range(0, this.props.tasks.length);
    //   console.log('tasks', tasks.length, this.props.tasks.length);
    // } else if (selectedRows === 'none') {
    //   tasks = [];
    // }

    // this.setState({ selectedRows });
  };

  renderNoData() {
    return (<TableRow>
      <TableRowColumn colSpan={3} style={styles.noDataRow}>
        <FontIcon className="material-icons" style={styles.noData}>person</FontIcon>
        <div>No tasks...</div>
      </TableRowColumn>
    </TableRow>);
  }

  renderStageStatus = (task, stage, index) => {
    let icon;
    if (task.stages && task.stages[stage.id] && task.stages[stage.id].assignedTo) {
      icon = (<FontIcon className="material-icons" style={styles.stage} color="green">done</FontIcon>);
    } else {
      icon = (<FontIcon className="material-icons" style={styles.stage} color="lightgrey">error</FontIcon>);
    }

    return (<TableRowColumn key={index} style={styles.stageCol}>{icon}</TableRowColumn >);
  };

  renderTask(task, i) {
    return (<TableRow
      key={task.id} className="table-row" selected={this.state.selectedRows.indexOf(i) >= 0}
    >
      <TableRowColumn
        headers="origin"
        className="td"
      >{formatLocation(task.origin)}</TableRowColumn>
      <TableRowColumn
        headers="destination"
        className="td"
      >{formatLocation(task.destination)}</TableRowColumn>
      { this.props.job.profile.stages.map((stage, index) => this.renderStageStatus(task, stage, index))}
    </TableRow>);
  }

  renderTasks() {
    // console.log(this.props.tasks);
    const tasks = (this.props.tasks || []).filter((task) => filterTask(task, this.state.query));
    const { job } = this.props;

    return (<div style={styles.resources}>
      <div>
        <Table
          selectable
          multiSelectable
          className="table"
          onRowSelection={this.handleTaskSelection}
        >
          <TableHeader displaySelectAll adjustForCheckbox className="table-header">
            <TableRow>
              <TableHeaderColumn>Origin</TableHeaderColumn>
              <TableHeaderColumn>Destination</TableHeaderColumn>

              { job.profile && job.profile.stages ? job.profile.stages.map((stage) => <TableHeaderColumn
                key={stage.id}
                style={styles.stageCol}
              ><img src={icons[stage.icon]} style={styles.stageIcon} alt={stage.name}/></TableHeaderColumn>) : null }
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox>
            { tasks.length > 0 ? tasks.map((task, i) => this.renderTask(task, i)) : this.renderNoData() }
          </TableBody>
        </Table>
      </div>
    </div>);
  }

  renderFilter(queryInstance, index) {
    return (<div key={index} style={styles.filterRow}>
      {index === 0 ? <h3 style={styles.header}> Where </h3> : null}
      <SelectField
        hintText="Name"
        value={queryInstance.where}
        onChange={(event, fakeIndex, value) => this.handleWhereChange(value, index)}
        style={commonStyles.input}
        autoWidth
      >
        {/* <MenuItem*/}
        {/* value="job Date" primaryText="Job Date"*/}
        {/* />*/}
        <MenuItem value={originExtractor} primaryText="Origin"/>
        <MenuItem value={destinationExtractor} primaryText="Destination"/>
        {/* <MenuItem value="stages unassigned" primaryText="Stages Unassigned"/>*/}
      </SelectField>

      <SelectField
        hintText="condition"
        value={queryInstance.condition}
        onChange={(event, fakeIndex, value) => this.handleConditionChange(value, index)}
        style={commonStyles.input}
        autoWidth
      >
        <MenuItem value="Contains" primaryText="contains"/>
        <MenuItem value="Does not contain" primaryText="does not contain"/>
        <MenuItem value="Is" primaryText="is"/>
        <MenuItem value="Is not" primaryText="is not"/>
        <MenuItem value="Is empty" primaryText="is empty"/>
        <MenuItem value="Is not empty" primaryText="is not empty"/>
      </SelectField>
      <TextField
        name={index.toString()}
        hintText="Value"
        value={queryInstance.substring}
        style={commonStyles.input}
        onChange={(event, value) => (this.handleChange(event, value, index))}
      />
      <FontIcon
        onClick={() => this.handleRemoveFilter(index)}
        style={styles.icon} className="material-icons"
      >
        delete
      </FontIcon>
    </div>);
  }

  render() {
    if (!this.props.job || !this.props.job.id) {
      return null;
    }

    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onClick={() => this.props.hideDialog('assignResourcesToTasks')}
      />,
      <FlatButton
        label={'Save'}
        primary
        keyboardFocused
        onClick={()=>this.handleSave()}
      />,
    ];
    return (
      <ReduxDialog
        name="assignResourcesToTasks"
        title="Assign Resources To Tasks"
        actions={actions}
        modal={false}
        autoScrollBodyContent
        bodyStyle={styles.body}
      >
        <div>{ this.state.query.map((rule, idx) => this.renderFilter(rule, idx)) }</div>
        <div style={styles.clear}>

          <FlatButton
            style={styles.flatBtn}
            label="Add filter"
            onClick={() => this.addFilter()}
            icon={<i style={styles.font} className="material-icons">add</i>}
          />
        </div>
        <br />
        <FlatButton
          label={`ASSIGN (${this.state.selectedRows.length > 0 ? this.state.selectedRows.length + ' ' : ''}${this.state.selectedRows.length > 1 ? 'TASKS' : 'TASK'})`}
          labelPosition="before"
          primary
          style={styles.selectedCount}
          onClick={() => this.handleAssignEmployeesToStages()}
          icon={<FontIcon
            className="material-icons"
            style={styles.stage}
          >person_add</FontIcon>}
        />
        { this.renderTasks() }
        <AssignEmployeesToStagesDialog />
      </ReduxDialog>
    );
  }
}

// const form = reduxForm({
//   form: 'AssignResourcesToTasks',  // a unique identifier for this form
//   initialValues: {},
// })(AssignResourcesToTasks);

function mapStateToProps(state) {
  return {
    job: state.get('jobs').get('job').toJS(),
    employees: state.get('employees').get('employees').toJS(),
    tasks: toArray(state.get('tasks').get('tasks').toJS()),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchEmployees,
    fetchTasks: (jobId) => fetchTasksRoutine.trigger({ jobId }),
    showDialog,
    hideDialog,
    showError,
    saveTaskAssignments: (tasks) => saveTaskAssignmentsRoutine.trigger(tasks),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignResourcesToTasks);



// WEBPACK FOOTER //
// ./src/components/AssignResourcesToTasks/index.js